import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-10 px-6 border-t" style={{
      backgroundColor: 'var(--bg-surface)',
      borderColor: 'var(--border-subtle)'
    }} data-id="element-162">
        <div className="max-w-[680px] mx-auto" data-id="element-163">
          {/* Payment trust badges */}
          <div className="flex items-center justify-center gap-3 mb-6 flex-wrap" data-id="element-164">
            {['Visa', 'Mastercard', 'PayPal', 'Amex', 'Apple Pay'].map(method => <div key={method} className="bg-[var(--bg-card)] border border-[var(--border-subtle)] rounded px-3 py-1.5 text-[10px] font-bold text-[var(--text-muted)] uppercase tracking-wider shadow-sm" data-id="element-165">
                  {method}
                </div>)}
          </div>

          <div className="flex justify-center items-center gap-6" data-id="element-166">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-[var(--text-muted)] hover:text-[var(--accent)] transition-colors cursor-pointer" data-id="element-167">
              Política de Privacidad
            </button>
            <span className="text-[var(--bg-elevated)]" data-id="element-168">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-[var(--text-muted)] hover:text-[var(--accent)] transition-colors cursor-pointer" data-id="element-169">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-center text-xs text-[var(--text-muted)] opacity-50 mt-4" data-id="element-170">
            © {new Date().getFullYear()} Plan B Migratorio. Todos los derechos
            reservados.
          </p>
          <p className="text-center text-[10px] text-[var(--text-muted)] opacity-30 mt-2" data-id="element-171">
            Este es un producto digital. No se enviará ningún producto físico.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-172">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-173">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} onClick={e => e.stopPropagation()} className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-sm w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-xl" data-id="element-174">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--border-subtle)]" data-id="element-175">
                <h3 className="text-lg font-serif text-[var(--text-heading)]" data-id="element-176">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors p-1" aria-label="Cerrar" data-id="element-177">
                  <X className="w-5 h-5" data-id="element-178" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-[var(--text-primary)] text-sm leading-relaxed space-y-4" data-id="element-179">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-180" /> : <TermsContent data-id="element-181" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-[var(--text-muted)] text-xs uppercase tracking-widest mb-4" data-id="element-182">
        Última actualización: Febrero 2026
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-183">
        1. Información que recopilamos
      </h4>
      <p data-id="element-184">
        Al adquirir "Plan B Migratorio", recopilamos únicamente la información
        necesaria para procesar tu compra: dirección de correo electrónico y
        datos de pago. No almacenamos datos de tarjetas de crédito directamente;
        estos son procesados de forma segura por nuestro proveedor de pagos.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-185">
        2. Uso de la información
      </h4>
      <p data-id="element-186">Tu información se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1 text-[var(--text-muted)]" data-id="element-187">
        <li data-id="element-188">Entregar el producto digital (método) a tu correo electrónico</li>
        <li data-id="element-189">Enviar confirmación de compra</li>
        <li data-id="element-190">Brindarte soporte si lo necesitas</li>
      </ul>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-191">
        3. Compartir información
      </h4>
      <p data-id="element-192">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros, excepto los proveedores de servicios necesarios para procesar
        tu compra y entrega del producto.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-193">
        4. Cookies
      </h4>
      <p data-id="element-194">
        Este sitio puede utilizar cookies esenciales para el funcionamiento
        básico de la página. No utilizamos cookies de seguimiento publicitario.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-195">
        5. Seguridad
      </h4>
      <p data-id="element-196">
        Implementamos medidas de seguridad razonables para proteger tu
        información personal. Sin embargo, ninguna transmisión por Internet es
        100% segura.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-197">
        6. Tus derechos
      </h4>
      <p data-id="element-198">
        Puedes solicitar la eliminación de tus datos personales en cualquier
        momento. Para ejercer este derecho, contáctanos y procesaremos tu
        solicitud en un plazo razonable.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-[var(--text-muted)] text-xs uppercase tracking-widest mb-4" data-id="element-199">
        Última actualización: Febrero 2026
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-200">
        1. Producto
      </h4>
      <p data-id="element-201">
        "Plan B Migratorio" es un producto digital en formato de guía
        descargable. Al completar la compra, recibirás acceso inmediato al
        archivo descargable.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-202">
        2. Uso personal
      </h4>
      <p data-id="element-203">
        El contenido de la guía es para uso personal y privado. No está
        permitido redistribuir, copiar, revender o compartir el material sin
        autorización expresa por escrito.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-204">
        3. Naturaleza del contenido
      </h4>
      <p data-id="element-205">
        Este producto es de carácter educativo e informativo. No constituye
        consejo legal o migratorio oficial. Si experimentas problemas legales
        severos, consulta a un abogado de inmigración certificado.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-206">
        4. Resultados
      </h4>
      <p data-id="element-207">
        Los resultados pueden variar de persona a persona. No garantizamos la
        obtención de visas o residencias, ya que dependen de factores
        individuales y de la aprobación de los gobiernos receptores.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-208">
        5. Política de reembolso
      </h4>
      <p data-id="element-209">
        Ofrecemos una garantía de 30 días. Si sientes que la guía no te
        proporciona un plan claro, contáctanos y procesaremos tu reembolso sin
        preguntas.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-210">
        6. Propiedad intelectual
      </h4>
      <p data-id="element-211">
        Todo el contenido, incluyendo textos, diseño y metodología, está
        protegido por derechos de autor. El uso no autorizado puede resultar en
        acciones legales.
      </p>

      <h4 className="text-base font-semibold text-[var(--text-heading)] mt-6 mb-2" data-id="element-212">
        7. Modificaciones
      </h4>
      <p data-id="element-213">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán efectivos al momento de su publicación en
        esta página.
      </p>
    </>;
}